import { render, staticRenderFns } from "./ProjectFormWall.vue?vue&type=template&id=20c57832&scoped=true"
import script from "./ProjectFormWall.vue?vue&type=script&lang=js"
export * from "./ProjectFormWall.vue?vue&type=script&lang=js"
import style0 from "./ProjectFormWall.vue?vue&type=style&index=0&id=20c57832&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c57832",
  null
  
)

export default component.exports